import styled from 'styled-components';

import {
  Icon as SemanticIcon,
  Dropdown as SemanticDropdown,
  Input as SemanticInput,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent, Segment as SegmentLayoutComponent } from '@playbookux/playbook-web-core';

export const TaskSegment = styled(SegmentLayoutComponent)`
  &&& {
    background: ${(props) => props.theme.color.segmentCreateProjectBackground};
    padding: 20px;
    margin: ${(props) => (props.isEdit ? '20px 0' : '0')};
    margin-bottom: 20px;
  }
`;

export const Input = styled(SemanticInput)`
  &&&.ui.input input {
    border: 1px solid transparent;
    color: ${(props) => props.theme.color.textLabel};
    font-weight: 500;
    font-size: 18px;
    margin-top: 0;
    padding: 0 0 3px 1px;
  }

  &&&.ui.input input:hover, &&&.ui.input input:focus, select {
    border-bottom: 2px solid ${(props) => props.theme.color.inputColor};
  }
`;

export const SurveyPageTitle = styled(TextLayoutComponent.Bold)`
  margin-bottom: 5px;
`;

export const ContainerBottom = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: ${(props) => props.direction};
  ${({ direction }) => direction === 'row' && 'align-items: baseline'};
`;

export const ContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ThreeDotContainer = styled.div`
  display: flex;
`;

export const CustomIcon = styled.div`
  display: flex;
`;

export const Dropdown = styled(SemanticDropdown)`
  &&& {
    &&:hover {
      background: ${(props) => props.theme.color.whtite};
    }
    &.active {
      background: ${(props) => props.theme.color.whtite};
    }
    &.ui.dropdown >.dropdown.icon {
      display: none;
    }
  }
`;

export const ImageIcon = styled.img`
  height: 20px;
  margin: auto;
  width: 26px;
`;

export const ItemContent = styled.div`
  color: ${({ errorColor, theme }) => (errorColor ? theme.color.textErrorProjetSetUp : theme.color.progress)};
`;

export const SurveyLabelContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const DefaultSurveyLabel = styled(TextLayoutComponent)`
  font-size: 15px;
  color: ${(props) => props.theme.color.textOptional};
`;

export const SkipLogicLabel = styled(TextLayoutComponent.Bold)`
  padding-top: 5px;
  margin-left: 5px;
  color: ${(props) => props.theme.color.textLabel};
  font-size: ${(props) => props.theme.fontSize.button};
`;

export const SkipLogicContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: fit-content;
  align-content: flex-end;
  align-self: flex-end;
  position: relative;
  margin-top: -30px;
  cursor: pointer;
`;

export const SkipLogicIcon = styled(SemanticIcon)`
  &&&{
    margin: 0;
    height: fit-content;
    width: fit-content;
    color: ${(props) => props.theme.color.black};
  }
`;
